import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {ChangeSet, FeatureToHideInHistoryView} from "../../order-history.model";
import {getProcessTypeFor, ProcessType} from "../../../../../store/state/order.state";
import {TranslationsHelperService} from "../../../../translations/translations-helper.service";

@Component({
    selector: 'historic-order-preview',
    templateUrl: './historic-order-preview.template.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HistoricOrderPreviewComponent {

	@Input() changeSet: ChangeSet;
	@Input() isLead: boolean;
	@Input() billingInfoVisible: boolean;
	@Input() latestOrderChanges: boolean;

	constructor(public translationsHelper: TranslationsHelperService) {}


	checkIfDocumentsUploaded(): boolean {
		if (this.isTransfer) {
			return this.changeSet.order.certificateFiles && this.changeSet.order.reportFiles && this.changeSet.order.certificateFiles.length > 0 &&
				this.changeSet.order.reportFiles.length > 0;
		} else {
			return false;
		}
	}

	get billingExists(): boolean {
		return !!this.changeSet.order.billingInformations;
	}

	get isTransfer(): boolean {
		return getProcessTypeFor(this.changeSet.order) == ProcessType.TRANSFER;
	}

	adjustChangeSet(changeSet: ChangeSet): ChangeSet {
		return {
			...changeSet,
			hideInHistoryView: [FeatureToHideInHistoryView.PRICE_FACTOR_INDICATORS]
		}
	}
}
